import { useTranslation } from 'next-i18next';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils/tailwind.util';
import { QuizImage } from './QuizImage';
import { QuizIndicatorChip } from './QuizIndicatorChip';
import { type HintType } from './types';

/**
 * QuizHint - 힌트 표시 컴포넌트
 * EditableQuizCard/EditableHint/HintContent.tsx와 일치
 * @component
 */

interface QuizHintProps {
  type: HintType;
  value: string;
  className?: string;
}
export const QuizHint = ({
  type,
  value,
  className
}: QuizHintProps) => {
  const {
    t
  } = useTranslation(['common']);
  if (!value) {
    return null;
  }
  return <div className={cn('block', className)} data-sentry-component="QuizHint" data-sentry-source-file="QuizHint.tsx">
      <div className="flex items-center gap-xs">
        <QuizIndicatorChip className="shrink-0" data-sentry-element="QuizIndicatorChip" data-sentry-source-file="QuizHint.tsx">
          {t('common:quizItem.hint.title')}
        </QuizIndicatorChip>
        <div className="grow">
          {type === 'text' && <span className="block break-all text-body-lg-medium text-alternative">
              {value}
            </span>}
          {type === 'image' && value && <QuizImage.Container className="size-[62px]" onClick={() => imageDetailModal.open(value)}>
              <QuizImage.Thumbnail src={value} alt="hint" />
            </QuizImage.Container>}
          {type === 'youtube' && value && <a href={value} target="_blank" rel="noopener noreferrer" className="break-all text-body-lg-medium text-link">
              {value}
            </a>}
        </div>
      </div>
    </div>;
};